import { render, staticRenderFns } from "./Atestados.vue?vue&type=template&id=1f561440&scoped=true"
import script from "./Atestados.vue?vue&type=script&lang=js"
export * from "./Atestados.vue?vue&type=script&lang=js"
import style0 from "./Atestados.vue?vue&type=style&index=0&id=1f561440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f561440",
  null
  
)

export default component.exports